import type { Dispatch, SetStateAction } from "react";
import Button from "../../../shared/components/Button";
import { siteTexts } from "../../../shared/i18n/siteTexts";
import type { AdminTournamentBracketMatch } from "../services/eventRegistrationAdminService";
import type { ScoreSetDraft } from "../utils/tournamentOperations";

export type AdminTournamentScoreModalState = {
  match: AdminTournamentBracketMatch;
  categoryKey: string;
  title: string;
  sets: ScoreSetDraft[];
};

type AdminTournamentScoreModalProps = {
  modal: AdminTournamentScoreModalState;
  onClose: () => void;
  onSave: () => void;
  saving: boolean;
  setModal: Dispatch<SetStateAction<AdminTournamentScoreModalState | null>>;
};

export default function AdminTournamentScoreModal({
  modal,
  onClose,
  onSave,
  saving,
  setModal,
}: AdminTournamentScoreModalProps) {
  const emptySet = (): ScoreSetDraft => ({
    gamesA: "",
    gamesB: "",
    tieBreakA: "",
    tieBreakB: "",
    isMatchTieBreak: false,
  });

  return (
    <div className="admin-tournament-score-modal" role="dialog" aria-modal="true">
      <div className="admin-tournament-score-dialog">
        <div className="admin-tournament-score-dialog-head">
          <h5>Resultado</h5>
          <Button type="button" variant="ghost" onClick={onClose}>
            {siteTexts.common.close}
          </Button>
        </div>
        <p>{modal.title}</p>
        <div className="admin-tournament-score-sets">
          {modal.sets.map((set, index) => (
            <div
              key={`score-set-${index + 1}`}
              className="admin-tournament-score-set"
            >
              <strong>Set {index + 1}</strong>
              <input
                type="number"
                min={0}
                placeholder="A"
                value={set.gamesA}
                onChange={(event) =>
                  setModal((current) =>
                    current
                      ? {
                          ...current,
                          sets: current.sets.map((item, itemIndex) =>
                            itemIndex === index
                              ? { ...item, gamesA: event.target.value }
                              : item,
                          ),
                        }
                      : current,
                  )
                }
              />
              <input
                type="number"
                min={0}
                placeholder="B"
                value={set.gamesB}
                onChange={(event) =>
                  setModal((current) =>
                    current
                      ? {
                          ...current,
                          sets: current.sets.map((item, itemIndex) =>
                            itemIndex === index
                              ? { ...item, gamesB: event.target.value }
                              : item,
                          ),
                        }
                      : current,
                  )
                }
              />
              <input
                type="number"
                min={0}
                placeholder="TB A"
                value={set.tieBreakA}
                onChange={(event) =>
                  setModal((current) =>
                    current
                      ? {
                          ...current,
                          sets: current.sets.map((item, itemIndex) =>
                            itemIndex === index
                              ? { ...item, tieBreakA: event.target.value }
                              : item,
                          ),
                        }
                      : current,
                  )
                }
              />
              <input
                type="number"
                min={0}
                placeholder="TB B"
                value={set.tieBreakB}
                onChange={(event) =>
                  setModal((current) =>
                    current
                      ? {
                          ...current,
                          sets: current.sets.map((item, itemIndex) =>
                            itemIndex === index
                              ? { ...item, tieBreakB: event.target.value }
                              : item,
                          ),
                        }
                      : current,
                  )
                }
              />
              <label className="admin-tournament-checkbox">
                <input
                  type="checkbox"
                  checked={set.isMatchTieBreak}
                  onChange={(event) =>
                    setModal((current) =>
                      current
                        ? {
                            ...current,
                            sets: current.sets.map((item, itemIndex) =>
                              itemIndex === index
                                ? {
                                    ...item,
                                    isMatchTieBreak: event.target.checked,
                                  }
                                : item,
                            ),
                          }
                        : current,
                    )
                  }
                />
                Super
              </label>
            </div>
          ))}
        </div>
        <Button
          type="button"
          variant="pill"
          onClick={() =>
            setModal((current) =>
              current
                ? {
                    ...current,
                    sets: [...current.sets, emptySet()],
                  }
                : current,
            )
          }
        >
          {siteTexts.admin.misc.addSet}
        </Button>
        <div className="admin-tournament-ops-actions">
          <Button type="button" variant="ghost" onClick={onClose}>
            {siteTexts.common.cancel}
          </Button>
          <Button type="button" variant="primary" disabled={saving} onClick={onSave}>
            Salvar resultado
          </Button>
        </div>
      </div>
    </div>
  );
}
